import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  // {
  //   path: '/adminLogin',
  //   component: () => import('@/views/login/adminLogin'),
  //   hidden: true
  // },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    hidden: true,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '首页', icon: 'dashboard', noCache: true, affix: true }
      }
    ]
  },
  {
    path: '/error',
    name: 'Error',
    component: Layout,
    redirect: '/error/404',
    hidden: true,
    children: [
      {
        path: '404',
        component: () => import('@/views/error/404/index')
      },
      {
        path: '401',
        component: () => import('@/views/error/401/index')
      }
    ]
  }
]

// 异步挂载的路由
// 动态需要根据权限加载的路由表
export const asyncRouterMap = [
  {
    path: '/pre',
    name: 'Pre',
    component: Layout,
    redirect: '/pre/index',
    meta: {
      resources: 'account',
      title: '系统用户管理'
    },
    children: [
      {
        path: 'user',
        name: 'PreUser',
        component: () => import('@/views/pre/user/index'),
        meta: {
          resources: 'pre_user',
          title: '用户管理'
        }
      },
      {
        path: 'role',
        name: 'PreRole',
        component: () => import('@/views/pre/role/index'),
        meta: {
          resources: 'pre_role',
          title: '角色管理'
        }
      },
      {
        path: 'index',
        name: 'PrePerm',
        component: () => import('@/views/pre/perm/index'),
        meta: {
          resources: 'pre_perm',
          title: '权限管理'
        }
      },
      {
        path: 'todo',
        name: 'todo',
        component: () => import('@/views/pre/todo/index'),
        meta: {
          resources: 'pre_todo',
          title: '便签'
        }
      }
    ]
  },
  {
    path: '/sys',
    name: 'Sys',
    component: Layout,
    redirect: '/sys/index',
    meta: {
      resources: 'sys',
      title: '系统设置'
    },
    children: []
  },
  {
    path: '/oauth2',
    name: 'oauth2',
    component: Layout,
    redirect: '/oauth2/clientDetails',
    meta: {
      resources: 'oauth',
      title: '单点登录'
    },
    children: [
      {
        path: 'user',
        name: 'user',
        component: () => import('@/views/sso/user/'),
        meta: { resources: 'sso_user', title: '用户管理' }
      },
      {
        path: 'userGroup',
        name: 'userGroup',
        component: () => import('@/views/sso/userGroup/'),
        meta: { resources: 'sso_user_group', title: '用户组管理' }
      },
      {
        path: 'app',
        name: 'app',
        component: () => import('@/views/sso/app/index'),
        meta: { resources: 'sso_app', title: '应用管理' }
      },
      {
        path: 'enterpriseIdentitySource',
        name: 'enterpriseIdentitySource',
        component: () => import('@/views/oauth2/clientDetails/enterpriseIdentitySource'),
        meta: { resources: 'enterprise_identity_source', title: '企业身份源' }
      },
      {
        path: 'sync',
        name: 'sync',
        component: () => import('@/views/sso/sync/'),
        meta: { resources: 'sso_sync', title: '同步中心' },
        children: [
          {
            path: 'ldap',
            name: 'ldap',
            component: () => import('@/views/sso/sync/ldap'),
            meta: { resources: 'sso_sync_ldap', title: 'LDAP同步' }
          }
        ]
      }
    ]
  },
  {
    path: '/ssl',
    name: 'ssl',
    component: Layout,
    redirect: '/ssl/sslUser',
    meta: {
      resources: 'ssl',
      title: 'SSL'
    },
    children: [
      {
        path: 'sslUser',
        name: 'sslUser',
        component: () => import('@/views/ssl/sslUser'),
        meta: { resources: 'ssl_user', title: '用户管理' }
      },
      {
        path: 'app',
        name: 'app',
        component: () => import('@/views/ssl/app'),
        meta: { resources: 'ssl_app', title: '应用管理' }
      }
    ]
  },
  {
    path: '/clientApplication',
    name: 'clientApplication',
    redirect: '/clientApplication/applicationManager',
    component: Layout,
    alwaysShow: true,
    meta: {
      resources: 'client_application',
      title: '客户端应用'
    },
    children: [
      {
        path: 'applicationManager',
        name: 'applicationManager',
        component: () => import('@/views/oauth2/clientDetails/applicationManager'),
        meta: { title: '应用管理', resources: 'application_manager' }
      }
    ]
  },
  {
    path: '/certificate',
    name: 'certificate',
    component: Layout,
    redirect: '/certificate/ca',
    alwaysShow: true,
    meta: {
      resources: 'certificate',
      title: '证书管理'
    },
    children: [
      {
        path: 'ca',
        name: 'ca',
        component: () => import('@/views/certificate/ca'),
        meta: { resources: 'ca', title: '根证书' }
      }
    ]
  },
  {
    path: '/record',
    name: 'record',
    component: Layout,
    redirect: '/record/script',
    alwaysShow: true,
    meta: { resources: 'record', title: '登录录制' },
    children: [
      {
        path: 'download',
        name: 'download',
        component: () => import('@/views/record/operateDownload'),
        meta: { resources: 'download', title: '驱动插件下载' }
      },
      {
        path: 'script',
        name: 'script',
        component: () => import('@/views/record/operateScript'),
        meta: { resources: 'script', title: '脚本管理' }
      },
      {
        path: 'playback',
        name: 'playback',
        component: () => import('@/views/record/playback'),
        meta: { resources: 'playback', title: '录制回放' }
      },
      {
        path: 'mapping',
        name: 'mapping',
        hidden: true,
        component: () => import('@/views/record/mapping'),
        meta: { resources: 'mapping', title: '用户关系映射' }
      }
    ]
  },
  {
    path: '/setting',
    name: 'setting',
    component: Layout,
    meta: {
      resources: 'setting',
      title: '系统设置'
    },
    children: [
      {
        path: 'log',
        name: 'log',
        component: () => import('@/views/pre/log/index'),
        meta: {
          resources: 'pre_log',
          title: '系统日志'
        },
        children: [
          {
            path: 'operation',
            name: 'operation',
            component: () => import('@/views/pre/log/operation/index'),
            meta: { resources: 'operation', title: '操作日志' }
          },
          {
            path: 'error',
            name: 'error',
            component: () => import('@/views/pre/log/error/index'),
            meta: { resources: 'error', title: '错误日志' }
          }
        ]
      },
      {
        path: 'backup',
        name: 'backup',
        component: () => import('@/views/pre/backup/index'),
        meta: {
          resources: 'backup',
          title: '备份还原'
        }
      },
      {
        path: 'version',
        name: 'version',
        component: () => import('@/views/pre/version/index'),
        meta: {
          resources: 'version',
          title: '版本信息'
        }
      }
    ]
  }
]

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
